import script from "./QuestionAnswer11.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionAnswer11.vue?vue&type=script&setup=true&lang=js"

import "./QuestionAnswer11.vue?vue&type=style&index=0&id=1d44fb36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d44fb36"]])

export default __exports__